import React, { useEffect, useState, useRef, useMemo } from 'react';
import axios from "axios";
import moment from 'moment';

import DashboardSummary from '../DashboardSummaryNew';
import * as DashboardConstants from '.././DashboardConstants';
import callPostApi from "../../../requests/PostRequests";
import * as Constants from '../../../requests/URLConstants';
import * as DashboardUtils from '../DashboardUtils.js';
import AutomataNameListView from './AutomataNameListView';
import HoursSaved from 'assets/image/HoursSaved.svg';
import SelfHealRate from 'assets/image/SelfHealRate.svg';
import SuccessRate from 'assets/image/SuccessRate.svg';
import TerminationRate from 'assets/image/TerminationRate.svg';
import CapacityUtilization from 'assets/image/capacity-utilization.svg';
import i18n from "../../../i18n";
import { v1 } from "uuid";
import TreemapFile from './TreemapFile';
import * as workspaces from '../../../config/WorkspaceConstants'

require('./AutomationBusiness.scss');

export default function AutomationBusiness(props) {
    const [SummaryLoading, setSummaryLoading] = useState(true);
    const [cbmData, setCBMData] = useState([]);
    const [showAutomataList, setShowAutomataList] = useState(false);
    const [automataList, setAutomataList] = useState([]);
    const [serviceProcessName, setServiceprocessName] = useState('');
    const [component, setComponent] = useState('');
    const [competency, setCompetency] = useState('');
    const [cbmDataUrl, setcbmDataUrl] = useState('');
    const [CBMSummaryData, setCBMSummaryData] = useState([]);
    const [automataNameLens, setAutomataNameLens] = useState(DashboardConstants.ROI)
    const [isClientSelected, setClientSelected] = useState(false);
    const [cbmDataLoading, setCbmDataLoading] = useState(true);
    const loadingLabel = i18n.t('pageHeader.app.loadingLabel');
    const WarningForFranchiseClientSelect = i18n.t('pageHeader.app.WarningForFranchiseClientSelect');
    const [rowData, setRowData] = useState([]);
    const [kpiValue, setKpiValue] = useState();
    const ROIData1 = useRef(0);

    const summaryData = (tRate, sRate, selfHealRate, capacityData) => {
        let summary = [
            {
                title: DashboardConstants.ROI,
                value: isNaN(ROIData1.current) ? 0 : ROIData1.current,
                //target: '2%'
            },
            {
                title: DashboardConstants.successrate,
                value: isNaN(sRate) ? 0 : sRate.toFixed(2),
                showPercent: true
            },
            {
                title: DashboardConstants.Terminationrate,
                value: isNaN(tRate) ? 0 : tRate.toFixed(2),
                showPercent: true
            },
            {
                title: DashboardConstants.CapacityUtilization,
                value: isNaN(capacityData) ? 0 : capacityData,
                showPercent: true
            }
            // ,
            // {
            //     title: "Self-heal rate(%)",
            //     value: isNaN(selfHealRate) ? 0 : selfHealRate.toFixed(2),
            //     //target: '2%'
            // }
        ]
        setCBMSummaryData(summary);
    }

    useEffect(() => {
        if (props.filterSelectionsAutomation.client[0]) {
            setClientSelected(true);
            setShowAutomataList(false);
            getCBMSummary(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
            getCBMData(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace, props.selectedKpi);
            getCBMAutomataList(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace, "", "", "");

        } else {
            setClientSelected(false);
        }
    }, [props.preferencesChanged, props.selectedKpi]);

    const getPayload = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, serviceProcessName, component, competency, selectedKpi) => {
        let calenderInterval = DashboardUtils.getCalenderInterval(timeFilterSelections);
        let timeZone = moment.tz.guess();
        let technology;
        let franchise;
        let client;
        let bodyJSON;

        if (workspace === workspaces.automation_ops) {
            technology = dashboardFilterSelectionsAutomation.technology;
            franchise = dashboardFilterSelectionsAutomation.franchise;
            client = dashboardFilterSelectionsAutomation.client;
            bodyJSON = {
                "filters": {
                    "time": {
                        "startDateTime": timeFilterSelections.startDateTime,
                        "endDateTime": timeFilterSelections.endDateTime
                    },
                    "franchises": franchise,
                    "clients": client,
                    "technologies": technology,
                    "deployment_models": dashboardFilterSelectionsAutomation.deployment_model,
                    "business_competencies": dashboardFilterSelectionsAutomation.competency,
                    "automata_priority": dashboardFilterSelectionsAutomation.priority,
                    "status": dashboardFilterSelectionsAutomation.status,
                    "automata_state": dashboardFilterSelectionsAutomation.automata_state,
                    "automata_name": dashboardFilterSelectionsAutomation.automata_activity_name,
                    "bot_id": dashboardFilterSelectionsAutomation.bot_id,
                    "buisness_component": dashboardFilterSelectionsAutomation.buisness_component
                },
                "interval": {
                    "calender_Interval": calenderInterval,
                    "time_zone": timeZone
                },
                "workspace": workspace,
                "serviceProcessName": serviceProcessName,
                "component": component,
                "competency": competency,
                "selectedKpi": selectedKpi
            };
        }
        return bodyJSON;
    };

    function prepareCBMData(resp) {

        let data = [
            [
                'Location',
                'Parent',
                'Market trade volume (size)',
                'Market increase/decrease (color)',
            ]
        ]
        let competencyBuckets = resp.aggregations.competency.buckets;
        //     ['Unilever', null, 0, 0],
        //     ['Customer', 'Unilever', 4, 0],

        data.push([props.filterSelectionsAutomation.client[0], null, 0, 0]);
        for (let i = 0; i < competencyBuckets.length; i++) {
            let competencyArr = [];
            competencyArr.push({ v: competencyBuckets[i].key, f: competencyBuckets[i].key.trim() }, props.filterSelectionsAutomation.client[0], competencyBuckets[i].component.buckets.length, Math.round(competencyBuckets[i].hoursSaved.value))
            data.push(competencyArr);
            let componentBuckets = competencyBuckets[i].component.buckets;
            for (let j = 0; j < componentBuckets.length; j++) {
                let idGenComponent = "";
                idGenComponent = componentBuckets[j].key + "@" + v1();
                data.push([{ v: idGenComponent, f: componentBuckets[j].key.trim() }, competencyBuckets[i].key, componentBuckets[j].serviceProcessName.buckets.length, Math.round(componentBuckets[j].hoursSaved.value)])
                let serviceProcessNameBuckets = componentBuckets[j].serviceProcessName.buckets;
                for (let k = 0; k < serviceProcessNameBuckets.length; k++) {
                    let idGen = "";
                    idGen = serviceProcessNameBuckets[k].key + v1();

                    data.push([{ v: idGen, f: serviceProcessNameBuckets[k].key.trim() }, idGenComponent, serviceProcessNameBuckets[k].automataName.buckets.length, Math.round(serviceProcessNameBuckets[k].hoursSaved.value)])

                    // let automataNameBuckets = serviceProcessNameBuckets[k].automataName.buckets;
                    // for (let l = 0; l < automataNameBuckets.length; l++) {
                    //  data.push([{ v: automataNameBuckets[l].key+v1(), f: automataNameBuckets[l].key.trim() }, idGen, automataNameBuckets.length])                   
                    // }

                }
            }

        }

        setCBMData(data);
        console.log("chartdata", data);
    }

    function prepareROIData(response) {
        let competencyBuckets = response.aggregations.competency.buckets;
        let ROISum = 0;
        for (let i = 0; i < competencyBuckets.length; i++) {
            let componentBuckets = competencyBuckets[i].component.buckets;
            for (let j = 0; j < componentBuckets.length; j++) {
                let serviceProcessNameBuckets = componentBuckets[j].serviceProcessName.buckets;
                for (let k = 0; k < serviceProcessNameBuckets.length; k++) {
                    let automataNameBuckets = serviceProcessNameBuckets[k].automataName.buckets;
                    for (let l = 0; l < automataNameBuckets.length; l++) {
                        ROISum = ROISum + automataNameBuckets[l].hoursSaved.value;
                    }
                }
            }

        }
        ROIData1.current = ROISum;
    }

    function prepareCBMDataSummary(response1, response2) {
        let competencyBuckets = response1.aggregations.competency.buckets;
        let terminationsRate = 0; let terminationsSum = 0;
        let successRate = 0; let total = 0; let totalSuccessRate = 0; let sRate = 0;
        let selfHealRate = 0; let selfHealRateSum = 0;
        let numOfAutomatas = 0;
        for (let i = 0; i < competencyBuckets.length; i++) {
            let componentBuckets = competencyBuckets[i].component.buckets;
            for (let j = 0; j < componentBuckets.length; j++) {
                let serviceProcessNameBuckets = componentBuckets[j].srvc_prc_name.buckets;
                for (let k = 0; k < serviceProcessNameBuckets.length; k++) {
                    let automataNameBuckets = serviceProcessNameBuckets[k]["automata name"].buckets;
                    numOfAutomatas = numOfAutomatas + automataNameBuckets.length;
                    for (let l = 0; l < automataNameBuckets.length; l++) {
                        terminationsSum = terminationsSum + automataNameBuckets[l]["Termination Rate"].value;
                        selfHealRateSum = selfHealRateSum + automataNameBuckets[l]["Self Heal Rate"].value;
                        total = automataNameBuckets[l]["doc_count"] - (automataNameBuckets[l]["ReRuns"].value + automataNameBuckets[l]["Schd Miss"].value);
                        sRate = (automataNameBuckets[l]["Completions"].value / total) * 100;
                        totalSuccessRate = totalSuccessRate + sRate;
                    }
                }
            }
        }
        //console.log(numOfAutomatas);
        terminationsRate = terminationsSum / numOfAutomatas;
        selfHealRate = selfHealRateSum / numOfAutomatas;
        successRate = totalSuccessRate / numOfAutomatas;
        // console.log(terminationsRate);
        // console.log(selfHealRate);
        // console.log(successRate);
        let buckets = response2.aggregations["Automata Name"].buckets;
        let sum = 0, avg = 0, Ctotal = buckets.length;
        buckets.map((bucketItem) => {
            sum = sum + bucketItem.Capacity_Management.value;
        })
        avg = sum / Ctotal;
        let capacityData = avg.toFixed(2);
        summaryData(terminationsRate, successRate, selfHealRate, capacityData);

    }


    function prepareAutomataList(automataResponse, processName, selectedKpi, component, competency) {
        let automataBuckets = automataResponse.aggregations["Automata Name"].buckets;
        let automataListObj = {}; let automataListArr = [];
        for (let i = 0; i < automataBuckets.length; i++) {
            let valTodisplay = setAutomataValue(selectedKpi, automataBuckets[i])
            automataListObj = {
                id: i,
                name: automataBuckets[i].key,
                value: valTodisplay,
                // tag: <TagComponent type='red'>-2.12%</TagComponent>,
                //gradient: <LinearGradient  colors={['red', 'yellow', 'green' ]} start={{ x: 0, y: 0.5 }} end={{ x: 1, y: 0.5 }}/>
            }
            automataListArr.push(automataListObj);
        }
        setAutomataList(automataListArr);
        console.log(automataList);
        setServiceprocessName(processName);
        setComponent(component);
        setCompetency(competency);
        setShowAutomataList(true);
    }

    const setAutomataValue = (selectedKpi, bucket) => {
        setAutomataNameLens(selectedKpi);
        switch (selectedKpi) {
            case DashboardConstants.ROI:
                return isNaN(bucket.hours_saved.value) ? 0 : (bucket.hours_saved.value).toFixed(2);
                break;
            case DashboardConstants.successrate:
                return ((bucket.Completions.value / (bucket.doc_count - bucket.ReRuns.value + bucket.Schd_Miss.value)) * 100).toFixed(2) + '%';
                break;
            case DashboardConstants.Terminationrate:
                return isNaN(bucket.Termination_Rate.value) ? 0 : (bucket.Termination_Rate.value).toFixed(2) + '%';
                break;
            case DashboardConstants.CapacityUtilization:
                return isNaN(bucket.Capacity_Management.value) ? 0 : (bucket.Capacity_Management.value).toFixed(2) + '%';
                break;
            case DashboardConstants.SelfHealRate:
                return isNaN(bucket.rate.value) ? 0 : (bucket.rate.value).toFixed(2) + '%';
                break;
            default:
                break;
        }

    }
    const getCBMSummary = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, "");
            axios.all([callPostApi(Constants.GETCBMSUMMARYDATA, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(response1 => {
                    if (response1) {
                        return response1;
                    }
                }),
            callPostApi(Constants.GETCBMAUTOMATALISTCAPACITYMANAGEMENT, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(response2 => {
                    if (response2) {
                        return response2;
                    }
                })]).then(axios.spread((response1, response2) => {
                    prepareCBMDataSummary(response1, response2);
                    setSummaryLoading(false);
                })).catch((error) => {
                    setSummaryLoading(false);
                });
                }
    }

        const getCBMData = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, selectedKpi) => {
            if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
                let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, "");
                setCbmDataLoading(true);
                callPostApi(prepareCbmUrl(selectedKpi), {
                    'Content-Type': 'application/json'
                }, bodyJSON)
                    .then(response => {
                        if (response) {
                            prepareCBMData(response);
                            if (props.selectedKpi === DashboardConstants.ROI)
                                prepareROIData(response);

                        }
                        setCbmDataLoading(false);
                    }).catch((error) => {
                        setCbmDataLoading(false);
                    });
            }
        }

        const prepareCbmUrl = (selectedKpi) => {
            switch (selectedKpi) {
                case DashboardConstants.ROI:
                    return Constants.GETCBMDATAROI;
                    break;
                case DashboardConstants.successrate:
                    return Constants.GETCBMDATASUCCESSRATE;
                    break;
                case DashboardConstants.Terminationrate:
                    return Constants.GETCBMDATATERMINATIONRATE;
                    break;
                case DashboardConstants.CapacityUtilization:
                    return Constants.GETCBMDATACAPACITY;
                    break;
                case DashboardConstants.SelfHealRate:
                    return Constants.GETCBMDATASELFHEALRATE;
                    break;
                default:
                    break;
            }

        }

        const getCBMAutomataList = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, serviceProcessName, component, competency) => {
            if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
                let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, serviceProcessName, component, competency, props.selectedKpi);
                let url = "";
                if (props.selectedKpi === DashboardConstants.ROI) {
                    url = Constants.GETCBMAUTOMATALIST;
                } else if (props.selectedKpi === DashboardConstants.CapacityUtilization) {
                    url = Constants.GETCBMAUTOMATALISTCAPACITYMANAGEMENT;
                } else {
                    url = Constants.GETCBMAUTOMATALISTEXCEPTROIKPI;
                }
                callPostApi(url, {
                    'Content-Type': 'application/json'
                }, bodyJSON)
                    .then(response => {
                        if (response) {
                            prepareAutomataList(response, serviceProcessName, props.selectedKpi, component, competency);
                        }
                    }).catch((error) => {
                    });
            }
        }

        const chartEvents =
            [
                {
                    eventName: "ready",
                    callback: ({ chartWrapper, google }) => {

                        google.visualization.events.addListener(chartWrapper.getChart(), 'onmouseover', function (e) {
                            var chart = chartWrapper.getChart();
                            var data = chartWrapper.getDataTable();

                            var value = data.getValue(e.row, 3);
                            console.log("hours saved", value);
                            if(props.selectedKpi === DashboardConstants.ROI){
                                value = value + "hrs"
                                setKpiValue(value);
                            }else {
                                value = value + "%"
                                setKpiValue(value);
                            }
                        });

                        var handler = function (competency) {
                            // var selection = chart.getSelection(), color;

                            var chart = chartWrapper.getChart();
                            var data = chartWrapper.getDataTable();
                            var selection = chart.getSelection();
                            // var options = chart.getOptions();
                            //setRowData(data);
                            if (selection.length > 0) {
                                // find data table rows for selected node name
                                var nodeName = selection[0].row;
                                var nodeRows = data.getFilteredRows([{
                                    column: 1,
                                    name: nodeName
                                }]);

                                // find row values for selected node name
                                nodeRows.forEach(function (row) {
                                    if (nodeName === row) {
                                        // console.log("test", data.getFormattedValue(row,0));
                                        var length = data.getValue(row, 2);
                                        var comp = data.getFormattedValue(row, 1);
                                        var ServiceProceeName = data.getFormattedValue(row, 0);
                                        var component = comp.split('@').shift();
                                        // setShowAutomataList(true);
                                        console.log("ServiceProceeNAme 2nd level", ServiceProceeName);
                                        console.log("component 2nd level", component);
                                        getCBMAutomataList(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace, ServiceProceeName, component, competency);
                                        // let enableList = true
                                        //callAutomataListView(enableList);
                                        // }
                                    }
                                    // else {
                                    //     //setShowAutomataList(false);
                                    // }
                                });
                            }
                            // chart.setSelection([]);

                        };

                        google.visualization.events.addOneTimeListener(chartWrapper.getChart(),
                            'select', function () {
                                var competency = "";
                                var component = "";

                                var chart = chartWrapper.getChart();
                                var data = chartWrapper.getDataTable();

                                var selection = chart.getSelection();

                                // var options = chart.getOptions();

                                if (selection.length > 0) {
                                    // find data table rows for selected node name
                                    var nodeName = selection[0].row;

                                    var nodeRows = data.getFilteredRows([{
                                        column: 1,
                                        name: nodeName
                                    }]);
                                    // find row values for selected node name
                                    nodeRows.forEach(function (row) {
                                        if (nodeName === row) {
                                            // console.log("test", data.getFormattedValue(row,0));
                                            var length = data.getValue(row, 2);
                                            var comp = data.getFormattedValue(row, 1);
                                            component = data.getFormattedValue(row, 0);
                                            var compExtract = comp.split('@').shift();
                                            // setShowAutomataList(true);
                                            // console.log("competency", ServiceProceeName);
                                            competency = compExtract;
                                            console.log("component First", component);
                                            console.log("competency First", competency);
                                            getCBMAutomataList(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace, "", component, competency);

                                        }
                                    });

                                }
                                google.visualization.events.addOneTimeListener(chartWrapper.getChart(), 'select', function () {
                                    handler(competency);
                                    google.visualization.events.addOneTimeListener(chartWrapper.getChart(), 'rollup', function () {
                                        console.log("rightclick");
                                        getCBMAutomataList(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace, "", "", "");
                                        getCBMData(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace, props.selectedKpi);
                                    });
                                });


                            });
                    }
                }
            ]


        const headers = [
            {
                key: DashboardConstants.name,
                header: DashboardConstants.Name,
            },
            {
                key: DashboardConstants.value,
                header: automataNameLens,
            },
            {
                key: DashboardConstants.tag,
                header: '',
            }
        ];

        const renderGradient = props.selectedKpi === DashboardConstants.ROI ? HoursSaved : props.selectedKpi === DashboardConstants.successrate ? SuccessRate : props.selectedKpi === DashboardConstants.Terminationrate ? TerminationRate  : props.selectedKpi === DashboardConstants.CapacityUtilization ? CapacityUtilization : SelfHealRate

        const renderTreeMap = useMemo(() => {
            return <TreemapFile chartEvents={chartEvents} cbmData={cbmData} cbmDataLoading={cbmDataLoading} rowData={rowData} kpiValue={kpiValue} kpi={props.selectedKpi} />
        }, [cbmData, props.selectedKpi, kpiValue])

        return (
            <div className="top-margin dashboard">
                {isClientSelected ? <div className="dashboard-detail-container col-lg-12 no-gutters">
                    <div className="automation dashboard-roleContainer col-lg-12">
                        <DashboardSummary loading={SummaryLoading} summary={CBMSummaryData} title={DashboardConstants.AutomationBusinessCatalogue} />
                    </div>
                    {cbmDataLoading === true ? <div>{loadingLabel}</div> :
                        <div className="dashboard-charts-container">
                            <div className="lens-gradient">
                                <div className="legend-title">{props.selectedKpi}</div>
                                <div className="gradient-img"> <img src={renderGradient} alt={props.selectedKpi} /></div>
                            </div>
                            {renderTreeMap}
                        </div>}
                    <div className="automata-list" style={{ marginTop: '20px' }}>
                        <AutomataNameListView rows={automataList} headers={headers} serviceProcessName={serviceProcessName} component={component} competency={competency} selectedKpi={props.selectedKpi} client={props.filterSelectionsAutomation.client[0]} />
                    </div>
                </div> : <div style={{ textAlign: "center" }}>{WarningForFranchiseClientSelect}</div>
                }
            </div >
        )
    }
